import {
  PiBugDuotone,
  PiCameraDuotone,
  PiCouchDuotone,
  PiFilmSlateDuotone,
  PiPottedPlantDuotone,
  PiScreencastDuotone,
  PiStarDuotone,
} from 'react-icons/pi';

import { IconTheatreDuotone } from '@spazious/dollhouse-icons';
import { useStoreApi } from '@spazious/dollhouse-store';
import { AidTooltip, Badge, ButtonProps, Stack, StackProps } from '@spazious/dollhouse-uikit';

// Constants
import {
  ROUTE_ABS_PATH_DECORATIONS,
  ROUTE_ABS_PATH_DEVTOOLS,
  ROUTE_ABS_PATH_FARRANGEMENTS,
  ROUTE_ABS_PATH_FURNITURES,
  ROUTE_ABS_PATH_REAL_TIME_SHARING,
  ROUTE_ABS_PATH_RECORDER,
  ROUTE_ABS_PATH_SHARE,
  ROUTE_ABS_PATH_TEMPLATES,
} from '../../constants/index.js';
import { useAidTooltipData } from '../../hooks/index.js';
// Components
import { Features } from '../Features/index.js';
import { MenuNavButton } from '../MenuNavButton/index.js';

export interface MenuNavButtonsProps extends StackProps {
  buttonSize?: ButtonProps['size'];
}

export const MenuNavButtons: React.FC<MenuNavButtonsProps> = ({
  buttonSize = 'medium',
  ...restProps
}) => {
  const getAidInfo = useAidTooltipData();
  const realTimeSharing = useStoreApi().rts();

  return (
    <Stack column {...restProps}>
      <Features features="farrangements">
        <AidTooltip {...getAidInfo('farrangements-panel')}>
          <MenuNavButton size={buttonSize} to={ROUTE_ABS_PATH_FARRANGEMENTS}>
            <IconTheatreDuotone />
          </MenuNavButton>
        </AidTooltip>
      </Features>
      <Features features="furnitures">
        <AidTooltip {...getAidInfo('furnitures-panel')}>
          <MenuNavButton size={buttonSize} to={ROUTE_ABS_PATH_FURNITURES}>
            <PiCouchDuotone />
          </MenuNavButton>
        </AidTooltip>
      </Features>
      <Features features="decorations">
        <AidTooltip {...getAidInfo('decorations-panel')}>
          <MenuNavButton size={buttonSize} to={ROUTE_ABS_PATH_DECORATIONS}>
            <PiPottedPlantDuotone />
          </MenuNavButton>
        </AidTooltip>
      </Features>
      <Features features="templates">
        <AidTooltip {...getAidInfo('templates-panel')}>
          <MenuNavButton size={buttonSize} to={ROUTE_ABS_PATH_TEMPLATES}>
            <PiStarDuotone />
          </MenuNavButton>
        </AidTooltip>
      </Features>
      <Features features="share">
        <AidTooltip {...getAidInfo('share-panel')}>
          <MenuNavButton size={buttonSize} to={ROUTE_ABS_PATH_SHARE}>
            <PiCameraDuotone />
          </MenuNavButton>
        </AidTooltip>
      </Features>
      <Features features="records">
        <AidTooltip {...getAidInfo('records-panel')}>
          <MenuNavButton size={buttonSize} to={ROUTE_ABS_PATH_RECORDER}>
            <PiFilmSlateDuotone />
          </MenuNavButton>
        </AidTooltip>
      </Features>
      <Features features="real-time-sharing">
        <AidTooltip {...getAidInfo('real-time-sharing')}>
          <Badge
            count={realTimeSharing.connections.length}
            visible={!!realTimeSharing.connections.length}
          >
            <MenuNavButton
              color={
                ['listening', 'connected'].includes(realTimeSharing.status) ? 'success' : undefined
              }
              size={buttonSize}
              to={ROUTE_ABS_PATH_REAL_TIME_SHARING}
            >
              <PiScreencastDuotone />
            </MenuNavButton>
          </Badge>
        </AidTooltip>
      </Features>
      <Features features="devtools">
        <MenuNavButton size={buttonSize} to={ROUTE_ABS_PATH_DEVTOOLS}>
          <PiBugDuotone />
        </MenuNavButton>
      </Features>
    </Stack>
  );
};
